import { useEffect } from 'react';

import { useMountedState } from '@gogame/hooks-ts';

import { useUpload } from 'scenes/Gallery/GalleryPage/Creatives/data';
import { uploadFileChunk } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

const useUploader = ({ file, processAsync }) => {
  const [progress, setProgress] = useMountedState(0);
  const [uploadCreativeFile] = useUpload({
    onProgress: (v) => {
      setProgress(v);
    },
    source: uploadFileChunk,
  });

  useEffect(() => {
    if (!file) {
      return;
    }
    return processAsync(uploadCreativeFile({ file }));
  }, [file]);

  return {
    progress,
  };
};

export default useUploader;
